const config = {
    API_URL: "https://efacturaoauth.era-erp.ro"
    //API_URL: "http://localhost:5001"
    //API_URL: "https://api.xtrm.ro/ApiERAPckXTRM"
}

export default config;